var map = {
	"./all.png": 9933,
	"./back.png": 4539,
	"./cardio.png": 6252,
	"./chest.png": 1159,
	"./lower arms.png": 3038,
	"./lower legs.png": 9816,
	"./neck.png": 1611,
	"./shoulders.png": 8619,
	"./upper arms.png": 5123,
	"./upper legs.png": 2229,
	"./waist.png": 2104
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 525;